import types from '../actions/types';

import {paginatedResultReducer, initialState} from './common/paginated_results';
import {
    removeItem
} from './common/remove-item';
const initial_state = {
    images: initialState
}

export default function(state = initial_state, action) {
    switch (action.type) {

        case types.DELETE_IMAGE.SUCCESS:
            return {
                ...state,
                images: {
                    ...state.images,
                    items: removeItem(state.images.items, action.payload.id)
                }

            }

        default:
            return {
                ...state,
                images: paginatedResultReducer(state.images, types.LOAD_IMAGES, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/image.js